<template>
  <div>
    <div>
      <q-toolbar class="bg-gray shadow-4 rounded-borders">
        <q-tabs align="left" inline-label dense indicator-color="#9ace25">
          <q-route-tab
            v-if="comprobar_is_admin()"
            to="/Presupuestos"
            label="Listado Presupuestos"
            name="listado"
          />
        </q-tabs>
      </q-toolbar>
    </div>

    <div id="Div9" runat="server">
      <TSZ_Comparativa />
    </div>
  </div>
</template>
<script>
import { Cookies } from 'quasar';

// import TSZ_Comparativa from "@/components/Comparativa/components/TSZ_Comparativa.vue";
import TSZ_Comparativa from '@/components/Comparativa/components/TSZ_ComparativaNueva.vue';

import '@/components/Comparativa/assets/css/css_comparativa_vue.css';
import '@/components/Presupuestos/assets/css/css_app_vue.css';

import { QTabs, QRouteTab, QToolbar } from 'quasar';

export default {
  init () {
    this.comprobar_is_admin();
  },
  data: function () {
    return {};
  },
  methods: {
    comprobar_is_admin () {
      // if (this.$store.getters['TSZ/CargaAccesoAdmin']===true) {
      if (process.env.VUE_APP_ACCESO_ADMIN === '1') {
        return true;
      } else return false;
    }
  },
  components: {
    TSZ_Comparativa,
    QTabs,
    QRouteTab,
    QToolbar
  }
};
</script>
